// Older alerts in the database carry shouty prefixes ("PANIC: North Gate",
// "TEST: Barn"). Show them in sentence case, like the iOS app does.
// public/sw.js keeps its own copy of this rule for push notifications.

const PREFIX = /^\s*(PANIC|TEST|FAILSAFE)\s*:\s*/i;

export function displayTitle(title: string): string {
  return title.replace(PREFIX, (_m, word: string) => `${word.charAt(0).toUpperCase()}${word.slice(1).toLowerCase()}: `);
}
